import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Code from 'UIComponents/elements/Code';
import FormulaEditorResolvedTag from 'automation-ui-formula-editor/formula-editor/FormulaEditorResolvedTag';
/* @ts-expect-error untyped module */
import { parse as editorExpressionParser } from 'automation-ui-formula-editor/formula-editor/grammar/editorExpression/editorExpressionParser';
import { toEditorExpression } from 'automation-ui-formula-editor/formula-editor/grammar/editorExpression/editorExpressionTransformer';
import { expressionToList, isFieldExpression, isFunctionCallExpression, isLiteralExpression } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
/* @ts-expect-error untyped module */
import { parse as hubLParser } from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
import parseWithErrors from 'automation-ui-formula-editor/formula-editor/grammar/parseWithErrors';
import { useMemo } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FormulaSummary = ({
  parsedExpression,
  formulaText,
  hubLFormulaText,
  shouldDisplayLiterals = false
}) => {
  const {
    parsedExpression: parsedEditorExpression
  } = useMemo(() => {
    let expression = parsedExpression;
    if (hubLFormulaText) {
      expression = parseWithErrors({
        parse: hubLParser,
        input: hubLFormulaText
      }).parsedExpression;
    }
    return parseWithErrors({
      parse: editorExpressionParser,
      input: expression ? toEditorExpression(expression) : formulaText || ''
    });
  }, [parsedExpression, formulaText, hubLFormulaText]);
  const expressionList = expressionToList(parsedEditorExpression);
  const functionNameList = expressionList.filter(isFunctionCallExpression).map(expr => expr.name) || [];
  const uniqueFunctionNameList = [...new Set(functionNameList)];
  if (shouldDisplayLiterals && expressionList.length === 1) {
    const [onlyExpression] = expressionList;
    if (isLiteralExpression(onlyExpression)) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: onlyExpression.value
      });
    } else if (isFieldExpression(onlyExpression)) {
      return /*#__PURE__*/_jsx(FormulaEditorResolvedTag, {
        fieldName: onlyExpression.name
      });
    }
  }
  if (uniqueFunctionNameList.length) {
    return /*#__PURE__*/_jsx(FormattedReactMessage
    /* @ts-expect-error style is not typed on FormattedReactMessage */, {
      style: {
        hyphens: 'none'
      },
      message: "automation-ui-formula-editor.formula.customFormula",
      options: {
        count: uniqueFunctionNameList.length,
        operationName: /*#__PURE__*/_jsx(Code, {
          children: uniqueFunctionNameList[0]
        }),
        operationList: /*#__PURE__*/_jsx(FormattedList, {
          children: uniqueFunctionNameList.map(name => /*#__PURE__*/_jsx(Code, {
            children: name
          }, name))
        })
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.formula.customFormulaFallback"
    });
  }
};
export default FormulaSummary;